import { useCallback, useMemo } from 'react';

import type { GetUserQuestionAnswersRankingResponse } from '@genially/contracts';

import { useSidebarSummaryWithContentContext } from '../../../SidebarSummaryWithContent.context';

export const useRankingSidebarData = () => {
  const {
    config: { countMySelfAsParticipant },
    currentUser: { alias: currentUserAlias },
    summary: { data },
  } = useSidebarSummaryWithContentContext();

  const fetchedData = data as GetUserQuestionAnswersRankingResponse;

  const getTotalData = useCallback(() => {
    if (fetchedData) {
      const dataWithoutMe = fetchedData.filter(
        user => user.userAlias !== currentUserAlias,
      );

      if (countMySelfAsParticipant) {
        return dataWithoutMe.length + 1;
      }

      return dataWithoutMe.length;
    }

    return 0;
  }, [fetchedData, countMySelfAsParticipant, currentUserAlias]);

  const totalData = useMemo(() => getTotalData(), [getTotalData]);

  return {
    aggregatedData: fetchedData,
    totalData,
  };
};
